import { PPDialog } from 'components/PPDialog'
import { VideoEditor } from './VideoEditor'
import styles from './VideoEditorDialog.pcss'

interface VideoEditorDialogProps {
  open?: boolean
  /** render inline in the parent component instead of a dialog */
  inline?: boolean
  video?: string
  exportFileName?: string
  editorClassName?: string
  hideExportButton?: boolean
  mediaId?: string
  onExport: (file: File, mediaId?: string) => void
  onClose?: () => void
}

export function VideoEditorDialog(props: VideoEditorDialogProps) {
  const { open, inline, video, hideExportButton, onExport, onClose } = props
  const handleExport = (file: File) => {
    onExport(file, props.mediaId)
  }
  const editor = <VideoEditor videoUrl={video} hideSaveButton={hideExportButton} onExport={handleExport} />

  if (inline) {
    return editor
  }

  return (
    <PPDialog
      open={Boolean(open)}
      onClose={onClose}
      title="Edit video"
      className={styles.dialog}
      data-testid="video-editor-dialog"
    >
      <div className={styles['dialog-content']}>
        {editor}
      </div>
    </PPDialog>
  )
}
